import React, { FC, useMemo } from 'react'

import { RewardsQuery } from '../../../../../graphql/search'
import { useCustomerVipDiscount } from '../../../../../lib/m2/hooks/useCustomerVipDiscount'
import { monthName, parseRewardsPeriod } from '../../../../../lib/rewards/periods'
import { RewardsIconWrapper } from '../RewardsIcon'
import * as Styled from './styled'

import Ribbon from '../../../../../img/rewards/ribbon.inline.svg'

export interface RewardsVipDiscountCardProps {
  className?: string
  previousSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const RewardsVipDiscountCard: FC<RewardsVipDiscountCardProps> = ({
  className,
  children,
  previousSnapshot,
}) => {
  const { vipDiscountPercent, isEligibleForVipDiscount, loading } = useCustomerVipDiscount()

  const month = useMemo(() => {
    const period = previousSnapshot?.period ? parseRewardsPeriod(previousSnapshot.period) : null
    return period ? monthName(period.month) : null
  }, [previousSnapshot?.period])
  if (loading || !isEligibleForVipDiscount) {
    return null
  }
  return (
    <Styled.Card className={className}>
      {children}
      <Styled.Container>
        <RewardsIconWrapper>
          <Ribbon />
        </RewardsIconWrapper>
        <Styled.Content>
          <Styled.Amount>{vipDiscountPercent}</Styled.Amount>
          <Styled.Text>Based on {month ?? "last month's"} sales</Styled.Text>
        </Styled.Content>
      </Styled.Container>
    </Styled.Card>
  )
}
